<template>
  <div class="report-arrears">
    <div class="totle-content">
      <div class="select-search">
        <div class="select-group">

        </div>
        <div class="button-group">
          <el-select placeholder="请选择房源" :value="selectHouseStr">
            <el-option :value="selectHouseStr">
              <el-tree :data="maintree"
                       :props="defaultProps"
                       highlight-current
                       @node-click="handleNodeClick"
                       ref="tree"></el-tree>
            </el-option>
          </el-select>
          <el-date-picker v-model="value0" type="date" placeholder="开始日期" value-format="yyyy-MM-dd"></el-date-picker>
          <el-date-picker v-model="value1" type="date" placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>

          <!--<el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels range-separator="至"-->
          <!--start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" value-format="yyyy-MM-dd" >-->
          <!--</el-date-picker>-->
          <el-button type="primary" icon="el-icon-search" @click="Water();">搜索</el-button>
          <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
        </div>

      </div>

      <div class="table-content">
        <el-table class="table-head" :data="waterData" border>
          <el-table-column align="center" type="index" width="50"></el-table-column>
          <el-table-column align="center" prop="title" label="设备名称" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column align="center" prop="pcode" label="设备号"></el-table-column>
          <el-table-column align="center" prop="date" label="日期" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" prop="initpower" label="开始度数"></el-table-column>
          <el-table-column align="center" prop="lastpower" label="结束度数"></el-table-column>
          <el-table-column align="center" prop="allpower" label="总用水量"></el-table-column>
          <el-table-column align="center" prop="price" label="单价（元）"></el-table-column>
          <el-table-column align="center" prop="addr" label="地址" show-overflow-tooltip min-width="250"></el-table-column>
          <!--<el-table-column align="center" prop="staydate" label="操作" min-width="50">-->
          <!--<template slot-scope="scope">-->
          <!--<el-button @click="toHouse(scope.$index, arrearsData)" type="text" size="small">查看</el-button>-->
          <!--</template>-->
          <!--</el-table-column>-->
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
  import store from "../store";
  var FileSaver = require('file-saver');

  export default {
    name: "ReportWater",
    data() {
      return{
        waterData:[],
        defaultProps:"",
        selectHouseStr:"",
        maintree:[],
        value0:"",
        value1:"",
        date_value:"",
        pickerOptions2:"",
        district:"",
        code:"",


      }
    },
    mounted(){
      this.ChooseHouse();

    },
    methods:{
      handleNodeClick(data) {
        console.log(data);
        this.district=data.district;
        this.code=data.code;
        this.selectHouseStr=data.label
      },

      //选择房源
      ChooseHouse(){
        this.$http.get(`${store.state.url}house?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
          .then((res) => {
            if(res.Code==0){
              var housedata = [];
              var data = res.Data;
              for (let i in data) {
                housedata[i] = {
                  label: data[i].Title,
                  children: [],
                  // zoneid: data[i].Zoneid,
                  district: data[i].Districtcode,
                  code: data[i].Code
                };
                if(data[i].Citys!=null){
                  for(let j in data[i].Citys){
                    housedata[i].children[j]={
                      label:data[i].Citys[j].Data.Title,
                      children:[],
                      district: data[i].Citys[j].Data.Districtcode,
                      code: data[i].Citys[j].Data.Code
                    };
                    if(data[i].Citys[j].Houses!=null){
                      for(let k in data[i].Citys[j].Houses){
                        housedata[i].children[j].children[k]= {
                          label:data[i].Citys[j].Houses[k].Data.Title,
                          children:[],
                          district: data[i].Citys[j].Houses[k].Data.Districtcode,
                          code: data[i].Citys[j].Houses[k].Data.Code
                        };
                        if(data[i].Citys[j].Houses[k].Houses!=null) {
                          for (let p in data[i].Citys[j].Houses[p]) {
                            housedata[i].children[j].children[k].children[p] = {
                              label: data[i].Citys[j].Houses[k].Houses[p].Data.Title,
                              children: [],
                              district: data[i].Citys[j].Houses[k].Houses[p].Data.Districtcode,
                              code: data[i].Citys[j].Houses[k].Houses[p].Data.Code
                            };
                            if(data[i].Citys[j].Houses[k].Houses[p]!=null) {
                              for (let q in data[i].Citys[j].Houses[p].Houses) {
                                housedata[i].children[j].children[k].children[p].children[q] = {
                                  label: data[i].Citys[j].Houses[k].Houses[p].Houses[q].Data.Title,
                                  children: [],
                                  district: data[i].Citys[j].Houses[k].Houses[p].Houses[q].Data.Districtcode,
                                  code: data[i].Citys[j].Houses[k].Houses[p].Houses[q].Data.Code
                                };

                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            this.maintree = housedata;
          })
      },

      //水表信息
      Water(){
        // var begin_date = this.date_value[0];
        // var end_date = this.date_value[1];
        this.$http.get(`${store.state.url}device/Water/bills/${this.district}/${this.code}/${this.value0}/${this.value1}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
          .then((res) => {
            if (res.Code == 0) {
              let arrearsData=[];
              if(res.Data!=null) {
                for (let i in res.Data) {
                  arrearsData[i] = {
                    title: res.Data[i].Expand.title,
                    pcode: res.Data[i].Expand.pcode,
                    addr: res.Data[i].Expand.addr,
                    initpower: res.Data[i].Initpower,
                    lastpower: res.Data[i].Lastpower,
                    allpower: res.Data[i].Allpower,
                    price: res.Data[i].Price,
                    date: res.Data[i].Date,
                  }
                }
              }
              this.waterData=arrearsData;
            } else {
              this.waterData=[];
              this.$message(res.Message);
            }
          })
      },

      //导出excel
      downloadMater (){
        const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
        const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
        const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

        let Data=[];
        for(let i in this.waterData){
          Data[i] = {
            设备名称: this.waterData[i].title,
            设备号: this.waterData[i].pcode,
            日期: this.waterData[i].date,
            开始度数: this.waterData[i].initpower,
            结束度数: this.waterData[i].lastpower,
            总用水量: this.waterData[i].allpower,
            单价: this.waterData[i].price,
            地址: this.waterData[i].addr
          };
        }
        let data = Data;
        wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

        //创建二进制对象写入转换好的字节流
        let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
        FileSaver.saveAs(tmpDown, "水表明细.xls");
      },
      //字符串转字符流
      s2ab (s) {
        if (typeof ArrayBuffer !== 'undefined') {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        } else {
          var buf = new Array(s.length);
          for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }
      },

      toHouse(index, row) {
        let devid = row[index].devid,
          tableInfo = {};
        window.localStorage.devid = devid;
        tableInfo.table = 1;
        tableInfo.index = '4';
        store.commit('assignReportPreTableTab', tableInfo);
        this.$router.push('./house');
      }
    }
  }
</script>

<style scoped>
  .button-group{
    /*margin-right:5px;*/
  }

  .button-group .el-date-editor{
    margin-left:10px;
  }
  .button-group .el-button{
    margin-left:10px;
  }

  .el-select{
    width:2.5rem
  }

  .el-select-dropdown__item {
    height: 2.5rem;
    overflow-y: scroll;
  }

  li.el-select-dropdown__item.hover {
    background-color: white;
  }
  .el-tree-node__content{
    font-size: 13px;
  }
  .el-form-item .el-select {
    width: 100%;
  }

</style>
